<template>
  <x-container fluid grid-list-lg>
    <x-layout>
      <x-flex xs12>
        <h2>Facility summary</h2>
      </x-flex>
    </x-layout>

    <x-layout>
      <x-flex xs12>
        <data-list :value="summary" />

        <document-list
          v-if="facility.id"
          class="mt-4"
          upload
          :documentable-id="facility.id"
          documentable-type="facility"
        />
      </x-flex>
    </x-layout>

    <x-layout>
      <x-flex xs12 text-xs-right>
        <x-btn class="ma-0" color="primary" @click="$emit('close')">Done</x-btn>
      </x-flex>
    </x-layout>
  </x-container>
</template>

<script>
  import DataList from '~/components/Shared/UIComponents/DataList';
  import DocumentList from '~/components/Shared/UIComponents/DocumentList.vue';

  export default {
    name: 'FacilitySummary',
    components: {
      DataList,
      DocumentList
    },
    props: {
      facility: {
        type: Object,
        required: true
      },
      summary: {
        type: Array,
        default: () => []
      }
    }
  };
</script>
